import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export default function AdaptiveIcon(props: FontAwesomeIconProps) {
  return <FontAwesomeIcon {...props} size={window.isApp ? "lg" : undefined} />;
}
